import { useAICredits } from '@/hooks/useAICredits';
import { Loader2, Coins } from 'lucide-react';
import { Button } from './ui/button';
import { cn } from '../lib/utils';
import { makeOverrideIcon } from './AppIcon';

type AICreditStatusProps = {
  onOpenWindow?: (appId: string, title: string) => void;
};

const CreditsIcon = makeOverrideIcon('credits', Coins);

export default function AICreditStatus({ onOpenWindow }: AICreditStatusProps) {
  const { account, loading } = useAICredits();

  const tone = account.exceeded
    ? 'bg-red-500/15 text-red-100 hover:bg-red-500/20'
    : account.low
      ? 'bg-amber-500/15 text-amber-50 hover:bg-amber-500/20'
      : 'bg-[hsl(var(--taskbar-btn))] text-inherit hover:bg-[hsl(var(--taskbar-btn-hover))]';

  return (
    <Button
      variant="taskbar"
      size="sm"
      onClick={() => onOpenWindow?.('ai-credits', 'AI Credits')}
      className={cn('h-8 px-3 !text-inherit', tone)}
      title="AI credits"
    >
      {loading ? <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" /> : <CreditsIcon size={14} className="mr-1 h-3.5 w-3.5 text-current" />}
      {account.availableCredits.toLocaleString()} credits
    </Button>
  );
}